import {useEffect} from "react";

interface ShortcutHandlers {
  onSearch?: () => void;   // "/" or Cmd+K / Ctrl+K
  onEscape?: () => void;   // "Escape" key
}

export const useKeyboardShortcuts = ({onSearch, onEscape}: ShortcutHandlers) => {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const tag = (e.target as HTMLElement).tagName;
      const isInput = tag === "INPUT" || tag === "TEXTAREA" || (e.target as HTMLElement).isContentEditable;

      // "/" when not in an input, or Cmd+K / Ctrl+K from anywhere
      const isCmdK = (e.metaKey || e.ctrlKey) && e.key === "k";
      if ((e.key === "/" && !isInput) || isCmdK) {
        e.preventDefault();
        onSearch?.();
      }

      if (e.key === "Escape") {
        onEscape?.();
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onSearch, onEscape]);
};
